<div class="mrh-contenedor">

  <div class="mrh-encabezado">
    <div>
      <h2>Bitácora de cambios</h2>
      <p class="mrh-sub">Matriz de Riesgos IA &middot; FOS-005 IA-001</p>
    </div>
    <button mat-stroked-button (click)="regresar()">Regresar</button>
  </div>

  <div class="mrh-cargando" *ngIf="loading">Cargando…</div>

  <div class="mrh-vacio" *ngIf="!loading && historial.length === 0">
    Sin movimientos registrados para este activo.
  </div>

  <table class="mrh-tabla" *ngIf="!loading && historial.length > 0">
    <thead>
      <tr>
        <th>Fecha</th>
        <th>Usuario</th>
        <th>Acción</th>
        <th>Campo</th>
        <th>Antes</th>
        <th>Después</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let h of historial">
        <td class="nw">{{ h.fechaCambio | fechaBitacora }}</td>
        <td>{{ h.usuarioNombre || '—' }}</td>
        <td><span class="mrh-accion" [class.alta]="h.accion === 'ALTA'">{{ h.accion }}</span></td>
        <td>{{ etiqueta(h.campoModificado) }}</td>
        <td class="mrh-valor">{{ h.valorAnterior || '—' }}</td>
        <td class="mrh-valor">{{ h.valorNuevo || '—' }}</td>
      </tr>
    </tbody>
  </table>

</div>
